import { Component } from 'react'
import { connect } from 'react-redux'
import { DEFAULT_CENTER } from 'components/common/Maps/Map'

class MySitesMapLoader extends Component {
  getMapPositions = () => {
    const MAP_PADDING = 1
    const mapCenter = DEFAULT_CENTER
    const mapBounds = {
      north: mapCenter.lat + MAP_PADDING,
      south: mapCenter.lat - MAP_PADDING,
      east: mapCenter.lng + MAP_PADDING,
      west: mapCenter.lng - MAP_PADDING,
    }

    const sites = this.props.sitesData.toArray()

    if (sites.length > 0) {
      let site = sites[0]
      mapBounds.north = site.location.latitude
      mapBounds.south = site.location.latitude
      mapBounds.east = site.location.longitude
      mapBounds.west = site.location.longitude
      delete sites[0]

      for (const i in sites) {
        if (sites.hasOwnProperty(i)) {
          site = sites[i]

          if (site.location.latitude > mapBounds.north)
            mapBounds.north = site.location.latitude

          if (site.location.latitude < mapBounds.south)
            mapBounds.south = site.location.latitude

          if (site.location.longitude > mapBounds.east)
            mapBounds.east = site.location.longitude

          if (site.location.longitude < mapBounds.west)
            mapBounds.west = site.location.longitude
        }
      }
    }

    const northSouthDictance = mapBounds.north - mapBounds.south
    const eastWestDictance = mapBounds.east - mapBounds.west

    if (northSouthDictance < MAP_PADDING) {
      mapBounds.north += (MAP_PADDING - northSouthDictance) / 2
      mapBounds.south -= (MAP_PADDING - northSouthDictance) / 2
    }

    if (eastWestDictance < MAP_PADDING) {
      mapBounds.east += (MAP_PADDING - eastWestDictance) / 2
      mapBounds.west -= (MAP_PADDING - eastWestDictance) / 2
    }

    mapCenter.lat = (mapBounds.north + mapBounds.south) / 2
    mapCenter.lng = (mapBounds.east + mapBounds.west) / 2

    return {
      mapCenter,
      mapBounds,
    }
  }

  shouldComponentUpdate(nextProps) {
    return this.props.mapPosition === nextProps.mapPosition
  }

  render() {
    const { activeMarker, mapPosition, mapRef } = this.props
    const map = mapRef

    if (
      map.current &&
      Object.entries(activeMarker.toJS()).length === 0 &&
      !mapPosition
    ) {
      const _mapPositions = this.getMapPositions()
      map.current.panTo(_mapPositions.mapCenter)
      map.current.fitBounds(_mapPositions.mapBounds)
    }

    return null
  }
}

export default connect(state => ({
  sitesData: state.getIn(['seaLice', 'sitesData']),
  activeSite: state.getIn(['seaLice', 'activeSite']),
  activeMarker: state.getIn(['seaLice', 'markerParams']),
  mapPosition: state.getIn(['seaLice', 'mapPosition']),
}))(MySitesMapLoader)
